import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { Divider } from './components/ui/Divider';
import { initMetaPixel, trackEvent } from './hooks/useMetaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackEvent('PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-brown selection:bg-gold/30 selection:text-brown-dark" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />

        <div className="bg-cream" data-id="element-5">
          <Divider data-id="element-6" />
        </div>

        <DeliverablesSection data-id="element-7" />
        <TargetAudienceSection data-id="element-8" />
        <HowItWorksSection data-id="element-9" />
        <ProofSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <OfferSection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}